import { render, staticRenderFns } from "./MediaFile.vue?vue&type=template&id=cb2ee166"
import script from "./MediaFile.vue?vue&type=script&lang=js"
export * from "./MediaFile.vue?vue&type=script&lang=js"
import style0 from "./MediaFile.vue?vue&type=style&index=0&id=cb2ee166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports